export default __webpack_public_path__ + "static/media/prev-E1A-BACK.5d3c686a.png";